import { render } from "./Statement.vue?vue&type=template&id=73f6680b"
import script from "./Statement.vue?vue&type=script&lang=js"
export * from "./Statement.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ANPHUVIET\\ebanking-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__